import useLocalStorage from "@hooks/useLocalStorage"
import Profile from "@whatsmenu/entities/dist/profile"
import { useEffect, useState } from "react"
import { Modal, Button } from 'react-bootstrap'
import { IoWarningOutline } from "react-icons/io5";

type Props = {
  profile?: Profile
}

export function KeetaRemoveAutoOrder({ profile }: Props) {
  const [showModal, setShowModal] = useState(false)
  const [alreadyShown, setAlreadyShown] = useLocalStorage<boolean>('keetaRemoveAutoOrderAlertShown', false)

  useEffect(() => {
      if (!profile) return
      const created =
        profile?.options?.integrations?.keeta?.merchant?.created_at
      if (!created) return
        setShowModal(true)
    }, [profile])

    const handleClose = () => {
    setShowModal(false)
    setAlreadyShown(true)
  }

  return (
    <>
      <style>{`
        @keyframes pulse-keeta {
          0%, 100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.1);
          }
        }
        .icon-pulse {
          animation: pulse-keeta 2s ease-in-out infinite;
        }
      `}</style>
      <Modal 
        show={showModal && !alreadyShown} 
        onHide={handleClose}
        centered
        backdrop="static"
        size="lg"
        keyboard={false}
      > 
        <Modal.Body className="d-flex flex-column align-items-center p-4 gap-3" >
            <div className="d-flex align-items-center justify-content-center icon-pulse" style={{backgroundColor: '#FBBF24', borderRadius: '17%'}}>
             <IoWarningOutline className="text-white m-2" size={60} />
            </div>
            <div className="d-flex flex-column gap-2 align-items-center justify-content-center text-center" style={{ color: '#012970' }}>
                <span className="fw-bold fs-4 ">ATENÇÃO, ACEITE AUTOMÁTICO DE PEDIDOS KEETA!</span>
                  <span className="fw-bold text-secondary" style={{fontSize:'1.2rem'}}>Por motivo de proteção de dados, A chave que ativa o “aceite automático de pedidos Keeta” encontra-se dentro do seu painel gestor Keeta e não mais no WhatsMenu!</span>
                  <span className="fw-bold text-secondary" style={{fontSize:'1.2rem'}}>A funcionalidade segue funcionando normalmente, basta ativar ou desativar no Keeta.</span>
              </div>
        
        <Modal.Footer className="border-top-0 justify-content-center pt-0 pb-0 mt-2 w-100">
          <Button 
            variant="primary" 
            onClick={handleClose}
            style={{
              backgroundColor: '#0477FF',
              borderColor: '#0477FF',
              padding: '10px 40px',
              fontSize: '16px',
              fontWeight: '600',
              borderRadius: '6px'
            }}
          >
            Entendi
          </Button>
        </Modal.Footer>
            </Modal.Body>
      </Modal>
    </>
  )
}